// extracted by mini-css-extract-plugin
export var close = "donate-module--close--jDlSg";
export var icon = "donate-module--icon--laYVM";
export var label = "donate-module--label---Nuya";
export var section = "donate-module--section--lP4i8";